export enum SiteAlertStateStoreModelEnum {
  NoIssues = 'NO_ISSUES',
  Alerts = 'ALERTS',
  Issues = 'ISSUES',
}

export enum BessStatusStoreModelEnum {
  Faulty = 'FAULTY',
  Performing = 'PERFORMING',
}

export enum ChargerOperationalStatusStoreModelEnum {
  Operational = 'OPERATIONAL',
  Maintenance = 'MAINTENANCE',
  Faulted = 'FAULTED',
  Offline = 'OFFLINE',
}

export enum ChargerStatusStoreModelEnum {
  Online = 'ONLINE',
  Offline = 'OFFLINE',
}

export enum SiteReadinessStateStoreModelEnum {
  Ready = 'READY',
  UnderCommissioning = 'UNDER_COMMISSIONING',
}

export enum SitesSortByStoreModelEnum {
  AlphabeticallyAscending = 'ALPHABETICALLY_ASCENDING',
  AlphabeticallyDescending = 'ALPHABETICALLY_DESCENDING',
}

export enum SitesViewModeStoreModelEnum {
  Cosy = 'COSY',
  Compact = 'COMPACT',
}
